// [BD feat] Collection filter — bd-collection-filter.js
// Progressive enhancement over the native <a href> single/bundle tag-filter URLs:
// intercept pill clicks, fetch the target view via the Section Rendering API
// (?section_id=…), swap only the results region with a fade/settle transition,
// keep the tag URL canonical via pushState, and support back/forward + reduced motion.
(function () {
  'use strict';

  var LEAVING = 'bd-collection-grid__results--leaving';
  var ENTERING = 'bd-collection-grid__results--entering';
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pathOf(href) {
    try {
      return new URL(href, window.location.origin).pathname;
    } catch (e) {
      return href;
    }
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function initFilters(filters) {
    if (!filters || filters.getAttribute('data-bd-init') === 'true') return;

    var sectionId = filters.getAttribute('data-bd-section-id');
    if (!sectionId) return;

    var root = filters.closest('.bd-collection-grid');
    if (!root) return;

    var results = root.querySelector('[data-bd-results]');
    if (!results) return;

    var pills = Array.prototype.slice.call(filters.querySelectorAll('[data-bd-pill]'));
    if (!pills.length) return;

    var busy = false;

    function setActivePill(url) {
      var target = pathOf(url);
      var matched = false;
      pills.forEach(function (pill) {
        var isActive = pathOf(pill.getAttribute('href')) === target;
        if (isActive) matched = true;
        pill.classList.toggle('btn-filter--active', isActive);
        pill.classList.toggle('bd-collection-grid__pill--active', isActive);
        pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      // Base collection URL (no active tag) → default view = singles = first pill.
      if (!matched && pills[0]) {
        pills[0].classList.add('btn-filter--active', 'bd-collection-grid__pill--active');
        pills[0].setAttribute('aria-pressed', 'true');
      }
    }

    function paintIn() {
      // Swap-in without a transition glitch: land at the entering state with the
      // transition disabled, commit a reflow, then re-enable and drop the class.
      results.classList.remove(LEAVING);
      results.style.transition = 'none';
      results.classList.add(ENTERING);
      void results.offsetWidth;
      results.style.transition = '';
      window.requestAnimationFrame(function () {
        results.classList.remove(ENTERING);
      });
    }

    function loadView(url, push) {
      if (busy) return;
      busy = true;

      var fetchUrl;
      try {
        fetchUrl = new URL(url, window.location.origin);
      } catch (e) {
        window.location.href = url;
        return;
      }
      fetchUrl.searchParams.set('section_id', sectionId);

      // Optimistic pill move — the CSS colour transition animates the navy fill.
      setActivePill(url);
      results.classList.add(LEAVING);

      Promise.all([
        fetch(fetchUrl.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        }).then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        }),
        wait(reduceMotion ? 0 : 220)
      ])
        .then(function (out) {
          var doc = new DOMParser().parseFromString(out[0], 'text/html');
          var fresh = doc.querySelector('[data-bd-results]');
          if (!fresh) throw new Error('no results region in response');

          // Pull relocated sections (e.g. testimonials marquee) out before wipe
          try {
            document.dispatchEvent(
              new CustomEvent('bd:collection-filter:before-swap', {
                detail: { results: results, url: url }
              })
            );
          } catch (err) {
            /* ignore */
          }

          results.innerHTML = fresh.innerHTML;

          // Injected cards are outside Wonder's scroll-trigger observer, so strip
          // the reveal classes to guarantee they render visible after the swap.
          var hidden = results.querySelectorAll('.scroll-trigger');
          Array.prototype.forEach.call(hidden, function (el) {
            el.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
          });

          paintIn();

          if (push) {
            window.history.pushState({ bdCollectionFilter: true, url: url }, '', url);
          }

          // Let infinite-scroll rebind to the swapped results + sentinel.
          try {
            document.dispatchEvent(
              new CustomEvent('bd:collection-filter:swapped', {
                detail: { results: results, url: url }
              })
            );
          } catch (err) {
            /* IE / very old — infinite scroll will re-init on next section load */
          }
        })
        .catch(function () {
          // Graceful fallback — behave like the plain link.
          results.classList.remove(LEAVING);
          window.location.href = url;
        })
        .then(function () {
          busy = false;
        });
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        // Let modified clicks (new tab / new window) behave natively.
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        var href = pill.getAttribute('href');
        if (!href) return;
        e.preventDefault();
        if (pathOf(href) === window.location.pathname) return;
        loadView(href, true);
      });
    });

    window.addEventListener('popstate', function () {
      loadView(window.location.pathname + window.location.search, false);
    });

    filters.setAttribute('data-bd-init', 'true');
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-bd-filters]:not([data-bd-init="true"])');
    Array.prototype.forEach.call(nodes, initFilters);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Theme editor — re-init when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target || !e.target.querySelector) return;
    initAll(e.target);
  });
})();
// [BD feat] Collection filter
